<div class="input-group">
    <div class="input-group-prepend">
        <button type="button" class="btn btn-light" (click)="goToUrl()">
            <i class="fas fa-external-link-alt" aria-hidden="true"></i>
        </button>
    </div>
    <input type="url" 
        class="form-control"
        #inputUrl
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        [attr.maxlength]="maxlength"
        (keyup)="onKeyup($event)">
</div>